import React, { Component } from 'react';
import InputGradesFilterStudents from '../../../StudentService/StudentServiceInputGrades/InputGradesFilterStudents';

class StudentFilterCourseEnrollment extends Component {
    componentDidMount() {
        localStorage.setItem('redirectType', 'courseEnrollment');
    }
    render() {
        return (
            <div>
                <h1>Upis na predmet</h1>
                <InputGradesFilterStudents
                    redirectType="courseEnrollment"
                />
            </div>
        );
    }
}

export default StudentFilterCourseEnrollment;



// WEBPACK FOOTER //
// ./src/views/Admin/Students/CourseEnrollment/StudentFilterCourseEnrollment.js